module.exports = __webpack_public_path__ + "static/jim-handsopen-a30684e240199ecce05926e554bd3f05.png";